import { getCanonicalUrl } from "@/utils/seoUtils";
import type { ElfEmergencyGuide } from "@/data/elfEmergencyGuides";

export const buildGuideSchema = (guide: ElfEmergencyGuide, canonicalUrl: string) => ({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Article",
      "@id": `${canonicalUrl}#article`,
      headline: guide.title,
      description: guide.description,
      url: canonicalUrl,
      inLanguage: "en-US",
      author: {
        "@type": "Organization",
        name: "Elf Letter Team",
        url: `${getCanonicalUrl("/about")}#editorial`,
      },
      publisher: {
        "@type": "Organization",
        name: "Elf Letter Bot",
        url: getCanonicalUrl("/"),
      },
      isPartOf: {
        "@type": "WebSite",
        name: "Elf Letter Bot",
        url: getCanonicalUrl("/"),
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: getCanonicalUrl("/"),
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Elf help",
          item: getCanonicalUrl("/elf-help"),
        },
        {
          "@type": "ListItem",
          position: 3,
          name: guide.title,
          item: canonicalUrl,
        },
      ],
    },
  ],
});
